(function () {
  function legacyCopy(url) {
    var input = document.createElement('textarea');
    input.value = url;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    input.remove();
    return copied;
  }

  function copyLink(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url).then(function () { return true; }, function () { return legacyCopy(url); });
    }
    return Promise.resolve(legacyCopy(url));
  }

  document.querySelectorAll('[data-pk-share]').forEach(function (button) {
    if (button.dataset.pkShareBound) return;
    button.dataset.pkShareBound = 'true';
    var label = button.querySelector('[data-pk-share-label]');
    var resetTimer;

    function showFeedback(message) {
      clearTimeout(resetTimer);
      label.textContent = message;
      resetTimer = setTimeout(function () { label.textContent = 'Share'; }, 2500);
    }

    // Always copy the product link (no native share sheet), so the button does the same thing everywhere.
    button.addEventListener('click', function () {
      var url = button.dataset.shareUrl;
      copyLink(url).then(function (copied) {
        if (copied) showFeedback('Link copied');
        else window.prompt('Copy product link:', url);
      });
    });
  });
})();
